module.exports = __webpack_public_path__ + "img/energySaving-icon_2.004c6e0b.png";